export const getDictionaryAction = type => {
  return {
    type: 'Get'.concat(type),
  };
};

export const appendDictionaryAction = (type, key, payload) => {
  return {
    type: 'Append'.concat(type),
    key,
    payload,
  };
};

export const prependDictionaryAction = (type, key, payload) => {
  return {
    type: 'Prepend'.concat(type),
    key,
    payload,
  };
};

export const insertDictionaryAction = (type, key, payload) => {
  return {
    type: 'Insert'.concat(type),
    key,
    payload,
  };
};

export const deleteDictionaryAction = (type, key, payload) => {
  return {
    type: 'Delete'.concat(type),
    key,
    payload,
  };
};

export const updateDictionaryAction = (type, key, updatedResult) => {
  return {
    type: 'Update'.concat(type),
    key,
    updatedResult,
  };
};
